import Head from 'next/head';
import React from 'react';

const seoDefaults = {
  canonical: 'https://healthunlocked.com',
  published_time: null,
  modified_time: null,
  title: 'HealthUnlocked',
  description: '',
  image: null,
  robots: null,
};

export default function (seo = seoDefaults, extra = '') {
  const { canonical, published_time, modified_time, title,
    description, image, robots, unreadCount, ogTitle } = seo;

  const baseTitle = title || 'HealthUnlocked | The social network for health';
  const titlePrefix = !unreadCount ? '' : `(${unreadCount}) `;
  const pageTitle = titlePrefix + baseTitle;

  return (
    <Head>
      <title>{pageTitle}</title>
      <meta name="description" content={description}/>
      <link rel="canonical" href={canonical}/>
      {!!published_time && <meta property="article:published_time" content={published_time}/>}
      {!!modified_time && <meta property="article:modified_time" content={modified_time}/>}
      {!!image && <meta property="og:image" content={image} />}
      {!!image && <meta property="og:image:secure_url" content={image} />}
      {!!robots && <meta property="robots" content={robots}/>}
      {!!ogTitle && <meta property="og:title" content={ogTitle}/>}
      <meta property="og:description" content={description}/>
      {extra}
    </Head>
  );
}



// WEBPACK FOOTER //
// ./src/utils/head.js